// extracted by mini-css-extract-plugin
export default {"tooltip":"OV-z","arrow":"PV-z"};